import type {
  NetworkLiveCaBreakdown,
  NetworkLiveCaSelectionParams,
  NetworkLiveTopProducts,
  NetworkLiveTopProductsSelectionParams,
} from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import {
  fetchNetworkLiveCaBreakdown,
  fetchNetworkLiveTopProducts,
} from '../queries/networkLiveCa.queries'

export const useNetworkLiveCaBreakdown = (
  selection: NetworkLiveCaSelectionParams,
  enabled = true,
): UseQueryResult<NetworkLiveCaBreakdown, unknown> =>
  useQuery({
    queryKey: ['get-network-live-ca-breakdown', selection.storeIds],
    queryFn: () => fetchNetworkLiveCaBreakdown(selection),
    enabled,
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
  })

export const useNetworkLiveTopProducts = (
  selection: NetworkLiveTopProductsSelectionParams,
  enabled = true,
): UseQueryResult<NetworkLiveTopProducts, unknown> =>
  useQuery({
    queryKey: ['get-network-live-top-products', selection.storeIds, selection.categoryIds],
    queryFn: () => fetchNetworkLiveTopProducts(selection),
    enabled,
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
  })
